exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".weekendBack[data-v-ac89c29a]{min-height:100%;background:-webkit-gradient(linear,left top,left bottom,from(#303030),color-stop(20%,#252525),color-stop(80%,#252525),to(#303030));background:linear-gradient(#303030,#252525 20%,#252525 80%,#303030)}.dayBorder[data-v-ac89c29a]{border-right:2px solid;border-left:2px solid;-o-border-image:linear-gradient(0deg,#303030,#707070 30%,#707070 70%,#303030);border-image:-webkit-gradient(linear,left bottom,left top,from(#303030),color-stop(30%,#707070),color-stop(70%,#707070),to(#303030));border-image:linear-gradient(0deg,#303030,#707070 30%,#707070 70%,#303030);border-image-slice:1}.btn--large[data-v-ac89c29a]{font-size:30px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ac89c29a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Settings.vue
// module id = 651
// module chunks = 0